import { atom } from 'jotai';

interface ShareInfoData {
  sharePlatform: string;
  sharePageName: string;
}

export const $ShareInfo = atom<ShareInfoData>({
  sharePlatform: '',
  sharePageName: '',
});
